import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
import { Box, Stack, SvgIcon, Typography } from "@mui/material";
import { AdminAPITypes } from "@stellar/api-logic";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE, DEFAULT_TEXT_FONT_WEIGHT } from "@styles/common-styles";
import InfoIcon from "@assets/icons/new/info_20px.svg?react";
import { CONSTRAINT_LABEL } from "@src/constants/subscription-constants";
import WarningIcon from "@assets/icons/new/exclamation-mark-circle-fill_24px.svg?react";
import { sphereColors } from "@styles/common-colors";

interface Props {
  /** Subscription constraint */
  constraint: AdminAPITypes.CreateConstraintPayload;
}

/** Details of a subscription constraint */
export function SubscriptionConstraint({ constraint }: Props): JSX.Element {
const constraintName = CONSTRAINT_LABEL[constraint.type].replace("active ", "");
  const constraintNameDisplay = constraint.data.max === 1
    ? constraintName.replace(/s$/, "")
    : constraintName;
  const isUserRoleConstraint = constraint.type === AdminAPITypes.EConstraintType.userRole;
  const shouldShowWarning = (constraint.data.current ?? 0) > (constraint.data.max ?? 0) && isUserRoleConstraint;
  
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Typography
        sx={{
          gap:1,
          display: "flex",
          alignItems: "center",
          fontSize: "20px",
          fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT,
          lineHeight: "30px",
        }}
      >
        { shouldShowWarning &&
          <SvgIcon
            component={WarningIcon}
            sx={{
              width: "20px",
              height: "20px",
              color: sphereColors.yellow600,
            }}
          />
        }
        {`${constraint.data.current} ${constraintNameDisplay}`}
          <Box
          component="span"
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
            fontWeight: DEFAULT_TEXT_FONT_WEIGHT,
            lineHeight: "20px",
          }}>
            {` / ${constraint.data.max}  limit set`}
          </Box>
      </Typography>
      
      {isUserRoleConstraint && (
        <SphereTooltipIcon
          icon={InfoIcon}
          text="An active member is a user that can make changes to a project"
        />
      )}
    </Stack>
  );
}